import password from './password';
import passwordCheck from './passwordCheck';
import confirmPassword from './confirmPassword';

export default {
  password,
  confirmPassword,
  passwordCheck,
};
